import { formatDisplayDate } from '@/apps/billing-shared/src/util/format-display-date';

export function formatDisplayDateShort(date) {
  return formatDisplayDate(date, false);
}
